import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHeader } from '../components/PageHeader';
import { Construction, Mail, Phone, MapPin } from 'lucide-react';
import { SEO } from '../components/SEO';
import { Link } from 'react-router-dom';
export function DonatePage() {
  return <div className="font-sans bg-warm-ivory min-h-screen w-full" data-id="element-525">
      <SEO title="Donate - Support SFRR Foundation" description="Support the Senator Fatimat Raji Rasaki Foundation. Your donation helps us improve lives and strengthen communities across Nigeria." keywords="donate to SFRR Foundation, support Nigerian nonprofit, humanitarian donation, community development donation" data-id="element-526" />

      <Header data-id="element-527" />
      <main className="w-full font-sans" data-id="element-528">
        <PageHeader title="Support Our Mission" subtitle="Your generosity transforms lives and builds stronger communities across Nigeria" badgeText="DONATE" backgroundImage="https://cdn.magicpatterns.com/uploads/6hdqakKu4rex18WGE6HiqM/SFRR_Foundation_(2).jpg" data-id="element-529" />

        {/* Under Construction Section */}
        <section className="py-20 bg-white" data-id="element-530">
          <div className="container mx-auto px-4" data-id="element-531">
            <div className="max-w-3xl mx-auto text-center" data-id="element-532">
              {/* Construction Icon */}
              <div className="w-24 h-24 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-8 animate-pulse" data-id="element-533">
                <Construction className="w-12 h-12 text-secondary" data-id="element-534" />
              </div>

              {/* Heading */}
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-6" data-id="element-535">
                Online Donations Coming Soon
              </h2>

              {/* Description */}
              <p className="text-lg text-neutral-600 leading-relaxed mb-8" data-id="element-536">
                We're currently setting up our secure online donation system to
                make it easier for you to support our mission. In the meantime,
                you can still contribute through the alternative methods below.
              </p>

              {/* Status Badge */}
              <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-secondary/10 text-secondary font-semibold mb-12" data-id="element-537">
                <div className="w-2 h-2 rounded-full bg-secondary animate-pulse" data-id="element-538" />
                Under Construction
              </div>
            </div>
          </div>
        </section>

        {/* Alternative Donation Methods */}
        <section className="py-16 bg-gradient-to-br from-primary/5 to-secondary/5" data-id="element-539">
          <div className="container mx-auto px-4" data-id="element-540">
            <div className="max-w-4xl mx-auto" data-id="element-541">
              <div className="text-center mb-12" data-id="element-542">
                <h2 className="text-2xl md:text-3xl font-serif font-bold text-charcoal mb-4" data-id="element-543">
                  How to Donate Now
                </h2>
                <p className="text-neutral-600" data-id="element-544">
                  You can support our work through these methods while we
                  finalize our online platform
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-545">
                {/* Bank Transfer */}
                <div className="bg-white rounded-2xl p-8 shadow-soft border border-neutral-100" data-id="element-546">
                  <div className="w-14 h-14 bg-primary/10 rounded-xl flex items-center justify-center mb-6" data-id="element-547">
                    <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-548">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" data-id="element-549" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-charcoal mb-4" data-id="element-550">
                    Bank Transfer
                  </h3>
                  <div className="space-y-3 text-neutral-600" data-id="element-551">
                    <div data-id="element-552">
                      <p className="text-sm font-semibold text-charcoal mb-1" data-id="element-553">
                        Bank Name
                      </p>
                      <p className="text-sm" data-id="element-554">[Bank details to be provided]</p>
                    </div>
                    <div data-id="element-555">
                      <p className="text-sm font-semibold text-charcoal mb-1" data-id="element-556">
                        Account Number
                      </p>
                      <p className="text-sm" data-id="element-557">[Account number to be provided]</p>
                    </div>
                    <div data-id="element-558">
                      <p className="text-sm font-semibold text-charcoal mb-1" data-id="element-559">
                        Account Name
                      </p>
                      <p className="text-sm" data-id="element-560">
                        Senator Fatimat Raji Rasaki Foundation
                      </p>
                    </div>
                  </div>
                </div>

                {/* Contact for Donations */}
                <div className="bg-white rounded-2xl p-8 shadow-soft border border-neutral-100" data-id="element-561">
                  <div className="w-14 h-14 bg-accent/10 rounded-xl flex items-center justify-center mb-6" data-id="element-562">
                    <Phone className="w-8 h-8 text-accent" data-id="element-563" />
                  </div>
                  <h3 className="text-xl font-bold text-charcoal mb-4" data-id="element-564">
                    Contact Us
                  </h3>
                  <p className="text-neutral-600 mb-6 text-sm" data-id="element-565">
                    Speak with our team to discuss donation options, partnership
                    opportunities, or learn more about our programs.
                  </p>
                  <div className="space-y-4" data-id="element-566">
                    <a href="tel:+2348033304041" className="flex items-center gap-3 text-neutral-700 hover:text-primary transition-colors" data-id="element-567">
                      <Phone className="w-5 h-5 text-primary flex-shrink-0" data-id="element-568" />
                      <span className="text-sm" data-id="element-569">+234 803 330 4041</span>
                    </a>
                    <a href="mailto:fatimarasakifoundation@gmail.com" className="flex items-center gap-3 text-neutral-700 hover:text-primary transition-colors" data-id="element-570">
                      <Mail className="w-5 h-5 text-primary flex-shrink-0" data-id="element-571" />
                      <span className="text-sm break-all" data-id="element-572">
                        fatimarasakifoundation@gmail.com
                      </span>
                    </a>
                  </div>
                </div>
              </div>

              {/* Office Locations */}
              <div className="mt-8 bg-white rounded-2xl p-8 shadow-soft border border-neutral-100" data-id="element-573">
                <h3 className="text-xl font-bold text-charcoal mb-6 flex items-center gap-3" data-id="element-574">
                  <MapPin className="w-6 h-6 text-primary" data-id="element-575" />
                  Visit Our Offices
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-576">
                  <div data-id="element-577">
                    <p className="text-sm font-semibold text-charcoal mb-2" data-id="element-578">
                      Head Office - Abuja
                    </p>
                    <p className="text-sm text-neutral-600 leading-relaxed" data-id="element-579">
                      Suite 48A, Shakir Plaza
                      <br data-id="element-580" />
                      Behind Assembly of God Church
                      <br data-id="element-581" />
                      Garki, Abuja. Nigeria
                    </p>
                  </div>
                  <div data-id="element-582">
                    <p className="text-sm font-semibold text-charcoal mb-2" data-id="element-583">
                      Branch Office - Ekiti
                    </p>
                    <p className="text-sm text-neutral-600 leading-relaxed" data-id="element-584">
                      Obayemi Mall
                      <br data-id="element-585" />
                      22A, Similoluwa Hospital Road
                      <br data-id="element-586" />
                      Ado-Ekiti, Ekiti State. Nigeria
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Impact Statement */}
        <section className="py-16 bg-white" data-id="element-587">
          <div className="container mx-auto px-4" data-id="element-588">
            <div className="max-w-3xl mx-auto text-center" data-id="element-589">
              <h2 className="text-2xl md:text-3xl font-serif font-bold text-charcoal mb-6" data-id="element-590">
                Every Donation Makes a Difference
              </h2>
              <p className="text-base md:text-lg text-neutral-600 leading-relaxed mb-8" data-id="element-591">
                Your contribution directly supports our programs in agriculture,
                healthcare, education, and humanitarian services. Together,
                we're building a better future for communities across Nigeria.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-592">
                {[{
                amount: '₦5,000',
                impact: 'Provides clean water access for 1 family'
              }, {
                amount: '₦25,000',
                impact: 'Supports education for 5 students'
              }, {
                amount: '₦50,000',
                impact: 'Delivers healthcare to 10 families'
              }].map((item, index) => <div key={index} className="bg-warm-ivory rounded-xl p-6 shadow-soft" data-id="element-593">
                    <p className="text-xl md:text-2xl font-bold text-primary mb-2" data-id="element-594">
                      {item.amount}
                    </p>
                    <p className="text-sm text-neutral-600" data-id="element-595">{item.impact}</p>
                  </div>)}
              </div>

              {/* CTA to Other Pages */}
              <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center" data-id="element-596">
                <Link to="/programs" className="px-6 py-3 bg-primary text-white rounded-full font-semibold hover:bg-primary-600 transition-all duration-300 hover:-translate-y-0.5 shadow-md hover:shadow-lg" data-id="element-597">
                  View Our Programs
                </Link>
                <Link to="/get-involved" className="px-6 py-3 bg-white text-charcoal border-2 border-neutral-200 rounded-full font-semibold hover:border-primary hover:text-primary transition-all duration-300" data-id="element-598">
                  Get Involved
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-599" />
    </div>;
}